export default (
	submitFormFn, moduleKey, submitIndex, setWasSubmitted, isPostFormSubmit,
	setSubmitsBlock, moduleId,
) => async (e, setLoading) => {
	e.preventDefault()
	if (setWasSubmitted) setWasSubmitted(true)
	if (setLoading) setLoading(true)
	if (setSubmitsBlock && moduleId) {
		setSubmitsBlock({ moduleId, isVisible: true })
	}
	try {
		await submitFormFn(moduleKey, submitIndex, false, isPostFormSubmit, e)
	} catch (er) {
		throw er
	} finally {
		if (setLoading) setLoading(false)
		if (setSubmitsBlock && moduleId && !isPostFormSubmit) {
			setSubmitsBlock({ moduleId, isVisible: false })
		}
	}
}
